import type React from 'react'
import type { PropsWithChildren } from 'react'

export const ModelConstraintsGrid: React.FC<PropsWithChildren> = ({
  children,
}) => (
  <div className="@container flex flex-wrap gap-4 items-stretch">
    {children}
  </div>
)

export const ModelConstraintWidth: React.FC<PropsWithChildren> = ({
  children,
}) => <div className="@[1000px]:w-[calc(50%-8px)] w-full flex">{children}</div>

export const ModelSetupTabContainer: React.FC<PropsWithChildren> = ({
  children,
}) => <div className="space-y-6">{children}</div>

export const ModelAssetClassContainer: React.FC<PropsWithChildren> = ({
  children,
}) => <div className="@container flex flex-wrap gap-4">{children}</div>

export const ModelAssetClassWidth: React.FC<PropsWithChildren> = ({
  children,
}) => <div className="@[600px]:w-[calc(50%-8px)] w-full">{children}</div>

export const ModelStateOptionsContainer: React.FC<PropsWithChildren> = ({
  children,
}) => <div className="flex flex-col gap-2">{children}</div>

export const ModelStateAllocationContainer: React.FC<PropsWithChildren> = ({
  children,
}) => (
  <div className="@container flex flex-wrap gap-4 mt-[20px]">{children}</div>
)

export const ModelStateAllocationWidth: React.FC<PropsWithChildren> = ({
  children,
}) => <div className="@[600px]:w-[calc(50%-8px)] w-full">{children}</div>

export const ModelLadderPolicyContainer: React.FC<PropsWithChildren> = ({
  children,
}) => <div className="space-y-[16px]">{children}</div>

export const ModelRatingRangeGrid: React.FC<PropsWithChildren> = ({
  children,
}) => <div className="grid grid-cols-1 md:grid-cols-2 gap-2">{children}</div>

export const ModelRatingRangeLeftInput: React.FC<PropsWithChildren> = ({
  children,
}) => <div className="order-2 md:order-1">{children}</div>

export const ModelRatingRangeRightInput: React.FC<PropsWithChildren> = ({
  children,
}) => <div className="order-1 md:order-2">{children}</div>

export const ModelFullWidthInput: React.FC<PropsWithChildren> = ({
  children,
}) => <div className="w-full">{children}</div>
